import React from 'react';
import { COLORS } from '../../styles/tokens';
import { remainingCredit } from '../../utils/invoicePayer';
import SegmentedControl from './newOrder/SegmentedControl';

const OPTIONS = [
  { value: 'card',    label: 'Kort' },
  { value: 'invoice', label: 'Faktura' },
];

// «Betales med: Kort / Faktura». Vises bare når bestilleren har godkjent fakturakunde (customer).
export default function PaymentMethodPicker({ value, onChange, customer, cardEnabled = true }) {
  if (!customer) return null;
  const options = cardEnabled ? OPTIONS : OPTIONS.filter(o => o.value === 'invoice');
  const current = cardEnabled ? value : 'invoice';
  return (
    <div style={styles.group}>
      <label style={styles.label}>Betales med</label>
      <SegmentedControl options={options} value={current} onChange={onChange} ariaLabel="Betales med" fill />
      {current === 'invoice' && (
        <div style={styles.info}>
          <div>Betalingsfrist {customer.termsDays} dager</div>
          <div>Gjenstående kreditt kr {remainingCredit(customer).toLocaleString('nb-NO')}</div>
          <div style={styles.note}>
            Sjåføren fakturerer deg via Tippi. Kredittgrensen sjekkes når en sjåfør tildeles.
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  group:    { display: 'flex', flexDirection: 'column', gap: 6 },
  label:    { fontSize: 12, fontWeight: 600, color: COLORS.textMid, marginTop: 4 },
  info:     { background: COLORS.blueBg, border: `1px solid ${COLORS.blueBorder}`, borderRadius: 14, padding: '10px 14px', fontSize: 13, color: COLORS.textDark, display: 'flex', flexDirection: 'column', gap: 2 },
  note:     { fontSize: 12, color: COLORS.textMid, marginTop: 4 },
};
